import { useNavigate } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * ContextBreadcrumb — "You are here" breadcrumb trail.
 * Usage: <ContextBreadcrumb items={[{label, path},...]} />
 */
const ContextBreadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  if (!items || items.length <= 1) return null;

  return (
    <nav className="flex items-center gap-1 text-[10px] mb-3 overflow-x-auto" data-testid="context-breadcrumb" aria-label="Breadcrumb">
      <button
        onClick={() => navigate("/dashboard")}
        className="text-[#8B95A5] hover:text-white transition-colors shrink-0"
        data-testid="breadcrumb-home"
      >
        <Home size={11} />
      </button>
      {items.slice(1).map((item, idx) => {
        const isLast = idx === items.length - 2;
        return (
          <span key={idx} className="flex items-center gap-1 shrink-0">
            <ChevronRight size={9} className="text-[rgba(255,255,255,0.15)]" />
            {isLast ? (
              <span className="text-white font-medium" data-testid={`breadcrumb-current`}>{item.label}</span>
            ) : (
              <button
                onClick={() => item.path && navigate(item.path)}
                className="text-[#8B95A5] hover:text-[#36A9E1] transition-colors"
                data-testid={`breadcrumb-${idx}`}
              >
                {item.label}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default ContextBreadcrumb;
